import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { FareRulesComponent } from './fare-rules.component';
@NgModule({
  declarations: [FareRulesComponent],
  imports: [CommonModule, StaticMsgModule, ButtonModule, TableSliderModule],
  exports: [FareRulesComponent],
})
export class FareRulesModule {}
